var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('EventHeader'),_c('RouterView',{key:`customer_${_vm.$route.name}_${_vm.componentKey}`,attrs:{"name":"customerContent"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }